export default __webpack_public_path__ + "static/media/ic_usdt_24.5ab8778d.svg";